// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import formatDate from '../../utilities/formatDate';

import '../../styles/archives.css';
import '../../styles/meta.css';

export default class SearchArchives extends React.Component {

    state = {
        query: "",
        stack: "",
        source: "",
        receivedFrom: "",
        receivedTo: ""
    }

    searchArchives = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.state.query.length < 3) return;
        this.props.search(this.state);
    }

    render = () => {
        return (<div className="meta-container">
        
            <div className="meta-details meta-details-nothumb">
                <div className="meta-details-name">Search through archives</div>

                <div className="archives-hint">
                    To search for multiple keywords, within multiple stacks, or from multiple sources, separate with commas.
                </div>

                <form className="archives-search" onSubmit={this.searchArchives}>

                    <label>Look for:</label>
                    <input
                        id="search"
                        name="search"
                        type="text"
                        value={this.state.query}
                        onChange={(e) => this.setState({ query: e.target.value })}
                        placeholder="Search keywords..."
                    />

                    <label>In stack(s):</label>
                    <input
                        id="stack"
                        name="stack"
                        type="text"
                        value={this.state.stack}
                        onChange={(e) => this.setState({ stack: e.target.value })}
                        placeholder="(Optional) Stack names"
                    />

                    <label>Source(s):</label>
                    <input
                        id="source"
                        name="source"
                        type="text"
                        value={this.state.source}
                        onChange={(e) => this.setState({ source: e.target.value })}
                        placeholder="(Optional) E-mail? Fax?"
                    />

                    <label>Received:</label>
                    <div className="archives-date-container">
                        <div
                            className="archives-date-button"
                            onClick={() => this.props.pickDate((receivedFrom, receivedTo) => this.setState({ receivedFrom, receivedTo }))}
                            style={this.state.receivedFrom && this.state.receivedTo ? {
                                fontSize: '13px'
                            } : {}}
                            title="Click to pick a date range"
                        >{this.state.receivedFrom && this.state.receivedTo ? formatDate(this.state.receivedFrom) + " → " + formatDate(this.state.receivedTo) : "Pick Date Range"}</div>
                    </div>

                    {this.state.query && this.state.query.length > 2 && <div className="archives-submit">
                        <input
                            type="submit"
                            value="Search"
                        />
                    </div>}

                </form>

            </div>

        </div>);
    }

};